import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import el from '~/locales/el.json';
import en from '~/locales/en.json';
import { BRAND_NAME } from '~/lib/brand';

/**
 * i18next bootstrap. Greek (el-GR) is the default/primary language; English is
 * the fallback for any missing key. Initialized in main.tsx before React mounts.
 */
// Restore the persisted language (shared key with the legacy admin); default to Greek.
const storedLanguage = (() => {
	try {
		return localStorage.getItem('I18N_LANGUAGE');
	} catch {
		return null;
	}
})();

void i18n.use(initReactI18next).init({
	resources: {
		el: { translation: el },
		en: { translation: en }
	},
	lng: storedLanguage === 'en' ? 'en' : 'el',
	fallbackLng: 'el',
	// `brand` is always available to interpolation so any `{{brand}}` in the locales
	// resolves to the tenant display name without threading it through every t() call.
	interpolation: { escapeValue: false, defaultVariables: { brand: BRAND_NAME } },
	returnNull: false
});

export default i18n;
